export const getErrorMessage = (error: unknown): string | null => {
  if (!error) return null;
  if (typeof error === 'object' && 'data' in error) {
    const data = (error as Record<string, unknown>).data;
    if (typeof data === 'object' && data !== null && 'detail' in data) {
      const detail = (data as Record<string, unknown>).detail;
      if (typeof detail === 'string') return detail;
    }
  }
  return null;
};
